import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../../environments/environment';
import { ConfigurationService } from '../../../../../Configuration/configuration.service';

@Injectable({
  providedIn: 'root'
})
export class TurnoverComponentService {

  URl = this.ConfigService.getAPIBaseUrl() + 'api/TurnoverRevenue'
  constructor(private http: HttpClient, private ConfigService: ConfigurationService) { }

  insertgriddetails(id:any,data: any) {
    //const httpOptions = { headers: new HttpHeaders({ 'content-type': 'text/json' }) }
    return this.http.post(this.URl + '/Adding?id=' + id, data)
  }
  insertdetails(data: any) {
    //const httpOptions = { headers: new HttpHeaders({ 'content-type': 'text/json' }) }
    return this.http.post(this.URl + '/Addingpagedata', data)
  }
  getdata(id: any) {
    return this.http.get(this.URl + '/Getdata?id=' + id)
  }
  getdata_LY(id: any) {
    return this.http.get(this.URl + '/Getdata_LY?id=' + id)
  }
  getgriddata(id: any) {
    return this.http.get(this.URl + '/Getgriddata?id=' + id)
  }
}
